import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Role } from '../../model/rolesAndPerms.model';
import { AdminService } from '../../service/admin.service';

type rolesAndPermsState = {
  roles: Role[];
  filterRoles: Array<{ roleName: string; roleId: string }>;
  selectedRole: Role | null;
};

const initialState: rolesAndPermsState = {
  roles: [],
  filterRoles: [],
  selectedRole: null,
};

export const fetchRoles = createAsyncThunk('roleAndPermissions/fetchRoles', async () => {
  const data = await AdminService.getRoles();
  return data;
});

export const fetchFilterRoles = createAsyncThunk(
  'roleAndPermissions/fetchFilterRoles',
  async () => {
    const data = await AdminService.getAllFilterRoles();
    return data;
  },
);

const rolesAndPermissionsSlice = createSlice({
  name: 'roleAndPermissions',
  initialState,
  reducers: {
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.roles = action.payload.roles;
    });
    builder.addCase(fetchFilterRoles.fulfilled, (state, action) => {
      state.filterRoles = action.payload.roles || [];
    });
  },
});

export const { setSelectedRole } = rolesAndPermissionsSlice.actions;
export default rolesAndPermissionsSlice.reducer;
